/**
 * Shared date formatting helpers. Use these instead of inlining
 * `new Date(x).toLocaleDateString(...)` so date display stays consistent
 * across the app (the codebase previously mixed en-GB and en-US inline).
 */

// "03 Jun 2026" — the app-standard short date.
export const formatDate = (value) => {
  if (!value) return "";
  try {
    return new Date(value).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return value;
  }
};

// "03 Jun 2026, 14:30" — when the time matters (audit logs, timestamps).
export const formatDateTime = (value) => {
  if (!value) return "";
  try {
    return new Date(value).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return value;
  }
};
